import * as React from 'react';
import * as moment from 'moment';
import {DatePicker} from 'antd';
import {MOMENT_DATE_FORMAT} from '../utils/date-utils';
import locales from '../locales';
import StaticFormItem from '../common/form-items/StaticFormItem';
import SectionHeaderFormItem from '../common/form-items/SectionHeaderFormItem';

interface Props {
  onRangeChanged: (start?: moment.Moment, end?: moment.Moment) => void;
  defaultStart?: moment.Moment;
  defaultEnd?: moment.Moment;
}

interface State {
  start?: moment.Moment;
  end?: moment.Moment;
}

export class InvoiceDateRangePicker extends React.Component<Props, State> {
  public state: State = {
    start: this.props.defaultStart,
    end: this.props.defaultEnd
  };

  public render() {
    const {start, end} = this.state;
    return (
      <div style={{display: 'block'}}>
        <SectionHeaderFormItem title={locales.filter_by_issue_date}/>
        <StaticFormItem
          label={locales.from}
          initialValue={
            <DatePicker
              value={start}
              placeholder={''}
              allowClear={true}
              format={MOMENT_DATE_FORMAT}
              disabledDate={this.startDatePickerDisabledDateFn}
              onChange={this.onStartChanged}
            />
          }
        />
        <StaticFormItem
          label={locales.to}
          initialValue={
            <DatePicker
              value={end}
              placeholder={''}
              allowClear={true}
              format={MOMENT_DATE_FORMAT}
              disabledDate={this.endDatePickerDisabledDateFn}
              onChange={this.onEndChanged}
            />
          }
        />
      </div>
    )
  }

  private onStartChanged = (start: moment.Moment) => {
    this.setState({start});
    this.props.onRangeChanged(start, this.state.end);
  };

  private onEndChanged = (end: moment.Moment) => {
    this.setState({end});
    this.props.onRangeChanged(this.state.start, end);
  };

  private startDatePickerDisabledDateFn = (current: moment.Moment | null): boolean => {
    let isDisabled = current !== null;
    if (current !== null) {
      isDisabled = current.isAfter(moment());
      if (this.state.end) {
        isDisabled = isDisabled || current.isAfter(this.state.end);
      }
    }
    return isDisabled;
  };

  private endDatePickerDisabledDateFn = (current: moment.Moment | null): boolean => {
    let isDisabled = current !== null;
    if (current !== null) {
      isDisabled = current.isAfter(moment());
      if (this.state.start) {
        isDisabled = isDisabled || current.isBefore(this.state.start);
      }
    }
    return isDisabled;
  };
}


// WEBPACK FOOTER //
// ./src/incoming-invoices/InvoiceDateRangePicker.tsx